<template>
  <div class="FormPartPropertiesComponent DataTables">
    
    <div :id="id"></div>


  </div>
</template>
<script>

  import PartPropertiesType from '@/constants/PartPropertiesType'
  var $ = require('jquery');
  var jQuery = $
  window.$ = $
  window.jQuery = $
  var jquery = $;
  import 'bootstrap-vue/dist/bootstrap-vue.css'

  require("datatables.net");
  require("datatables.net-bs4");



  import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'

  import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'


  import { mapGetters } from 'vuex'


    export default {
        name: "FormPartPropertiesComponent",
        props:{
          lang: Object,

        },
        components: {

        },
        data () {
            return {
              name: "FormPartPropertiesComponent",
              id: "tableplace_"+this._uid,
              propertiesType: [],
              propertyId: "",
              properties: [],
              mainTable: "",
              libraryCategories: []
            }
        },
        computed: {

          ...mapGetters({
            selectedTreeItemObject: 'selectedTreeItemObject',
            appConf: 'appConf',
          }),
          categoryId(){
            if (this.selectedTreeItemObject.categoryId == undefined){
              return 1;
            }
            return this.selectedTreeItemObject.categoryId;
          },
          reloadedAfterActionComplex() {
            return this.$store.getters.reloadedAfterActionComplex;
          },
          designationTypes(){
            
            const tab = [];
            for (let i = 0, lei = this.lang.CISDesignationTypes.length; i < lei; i++){
                            
              tab.push({type: i, name: this.lang.CISDesignationTypes[i]});
                       
            }
            return tab;
          },
          designationHDLTypes() {

            const tab = [];
            for (let i = 0, lei = this.lang.HDLDesignationTypes.length; i < lei; i++) {

              tab.push({ type: i, name: this.lang.HDLDesignationTypes[i] });

            }
            return tab;
          },
          existingTypes(){
            return this.$store.getters.existingTypes;
          },
          variant(){
            if (this.$store.getters.s_skinVariant == "dark"){
              return "light";
            }else{
              return "dark";
            }
            
          }

        },


        created () {
          
        },
        watch: {
          categoryId: function(newValue){



            this.getProperties(newValue, this);


          },
          reloadedAfterActionComplex: {
            handler: function (newValue) {

              for (let el in newValue) {
                if (newValue[el].name == this.name) {
                  if (newValue[el].status == true) {

                    this.getProperties(this.categoryId, this);

                    newValue[el].status = false;

                    this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
                  }
                }
              }
            },
            deep: true

          },
          


        },
        updated() {
          

        },
        mounted: function () {
          
          let _vue = this;

          


          this.$store.dispatch(this.$store.getters.sectionPrefix + "_getPropertiesType")
          .then(function(result) {
            
            console.log(result.data)

            for (let i = 0, lei = result.data.length; i < lei; i++){

              if (_vue.appConf.status.isHDL == false && result.data[i] == "hdl symbol") {
                
              } else {
                _vue.propertiesType.push({ value: result.data[i], text: result.data[i] });
              }
                
              
              
            }
                     
            _vue.getProperties(_vue.categoryId, _vue)
          })

          this.$store.dispatch(this.$store.getters.sectionPrefix + "_getGenericCategories")
          .then(function (result) {

            console.log(result.data)

            for (let i = 0, lei = result.data.length; i < lei; i++) {

              let temp = result.data[i].category.split("\\");
              temp.splice(0, 1);

              let text = temp.join('\\');


              _vue.libraryCategories.push({ value: result.data[i].categoryId, text: text });


            }

            _vue.getProperties(_vue.categoryId, _vue)
          })

        },
        methods: {
          getProperties(_categoryId, _vue){
            let obj = {
              categoryId: _categoryId
            }

            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_getProperties", obj)
            .then(function(result) {
              console.log(result)
              if (result.status == "OK"){

                const existingTypes = [];
                for(let i = 0, lei = result.data.length; i < lei; i++){
                  for(let j = 0, lej = _vue.propertiesType.length; j < lej; j++){
                    if (result.data[i].type == _vue.propertiesType[j].value){
                      if(!existingTypes.includes(result.data[i].type)){
                        existingTypes.push(result.data[i].type);
                      }
                      
                    }
                  }
                  
          
                }

                _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setExistingTypes", existingTypes);

                for(let i = 0, lei = _vue.propertiesType.length; i < lei; i++){

                  
                  if (!existingTypes.includes(_vue.propertiesType[i].value) || (_vue.propertiesType[i].value == "text")){
                    _vue.propertiesType[i].disabled = false;
                  }else{
                    _vue.propertiesType[i].disabled = true;
                  }


                }

                

                for(let i = 0, lei = result.data.length; i < lei; i++){

                  
                  result.data[i].propertiesType = _vue.propertiesType;
                  
                  result.data[i].designationTypes = _vue.designationTypes;
                  result.data[i].designationHDLTypes = _vue.designationHDLTypes;
                  result.data[i].libraryCategories = _vue.libraryCategories;
          
                }
                _vue.properties = result.data;

                let lastPriority = {
                  priority: 0,
                  id: 0
                };
                for (let i = 0, lei = _vue.properties.length; i < lei; i++){
                  _vue.properties[i].lastPriority = false;
                  if (_vue.properties[i].priority > lastPriority.priority) {
                    lastPriority.priority = _vue.properties[i].priority;
                    lastPriority.id = i;
                  }

                }
                
                _vue.properties[lastPriority.id].lastPriority = true;
                _vue.buildTable()
              }
              

            })
          },

          buildTable(){
            

            
            this.$store.dispatch("resetPropertyToSaving");

            var tableplace = document.getElementById("tableplace_"+this._uid);

            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }



            var place = document.createElement("table");
            place.setAttribute("id", "place"+this._uid);
            place.setAttribute("class", "table table-striped table-bordered");
            place.setAttribute("style", "width:100%;");
            tableplace.appendChild(place)

            var tr1 = document.createElement("tr");
            tr1.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr1);
            place.appendChild(thead);

            var tr2 = document.createElement("tr");
            tr2.setAttribute("class", "cellFooter");
            var tfoot = document.createElement("tfoot");
            tfoot.appendChild(tr2);
            place.appendChild(tfoot);

            var cols = [];

            var columnDefs = [];

            let columns = [
              {
                name: "Id",
                alignInColumn: "left",

              },
              {
                name: "Priority",
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Priority,
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Origins,
                alignInColumn: "center",

              },
              {
                name: this.lang.table_header_Name,
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Type,
                alignInColumn: "left",
              },
              {
                name: this.lang.table_header_Request,
                alignInColumn: "left",
              },
              {
                name: this.lang.table_header_Release,
                alignInColumn: "left",
              },
              {
                name: this.lang.table_header_Revision,
                alignInColumn: "left",
              },
              {
                name: this.lang.table_header_SearchString,
                alignInColumn: "left",
              },
              {
                name: this.lang.table_header_CISDesignation,
                alignInColumn: "left",
              },
              {
                name: this.lang.table_header_CISBrowsable,
                alignInColumn: "left",
              },
              {
                name: this.lang.table_header_HDLDesignation,
                alignInColumn: "left",
              },
              {
                name: this.lang.table_header_MaxLength,
                alignInColumn: "left",
              },
              {
                name: this.lang.table_header_LibraryCategoryId,
                alignInColumn: "left",
              },
              {
                name: this.lang.table_header_Actions,
                alignInColumn: "left",
              }
            ]

            let _vue = this;

            var len = columns.length;
            for (let i = 0; i < len; i++){



              var el = {};

              el = {
                targets: i,
                className: '_dt-body-'+ columns[i].alignInColumn,
                render: function ( data, type, row, meta ) {
                  let disabled = "";
                  if (row.origins != "own"){
                    disabled = "disabled=\"disabled\"";
                  }
                  if (meta.col == 0){

                    return data
                  } else if (meta.col == 1) {
                    

                    return data;    
                  } else if (meta.col == 2) {
                    let arrow_disabled1 = "";
                    let arrow_disabled2 = "";
                    
                    if (row.priority == 1) {
                      arrow_disabled2 = "disabled=\"disabled\"";
                    } else if (row.lastPriority == true) {
                      arrow_disabled1 = "disabled=\"disabled\"";
                    } 
                    
                    let str = "<button " + arrow_disabled1 + " id=\"down__" + row.propertyId + "\" class=\"btn btn-arrow btn-" + _vue.variant + "\">&ShortDownArrow;</button><button " + arrow_disabled2 + " id=\"up__" + row.propertyId + "\" class=\"btn btn-arrow btn-" + _vue.variant + "\">&ShortUpArrow;</button>" 
                    

                    

                    return str;  
                  }else if(meta.col == 3){

                    let variant = "success";
                    if (data == "ancestor"){
                      variant = "warning";
                    }else if (data == "descendant"){
                      variant = "danger";
                    }

                    return "<span class='badge badge-"+variant+"'>" + data + "</span>";
                  }else if(meta.col == 4){
                    if (type === "sort"){
                      return data;
                    }
                    if (type === "filter"){
                      return data;
                    }
                    

                    let str = "<input "+disabled+" class=\"form-control input-props\" type=\"text\" id=\"name_" + row.propertyId +"\" value=\"" + data + "\"></input>";
                    return  str;
                  }else if(meta.col == 5){
                    let disabled2 = "";

                    if (row.type == PartPropertiesType.TYPE) {
                      disabled = "disabled=\"disabled\"";
                    }
                    if (row.type == PartPropertiesType.PARTNUMBER) {
                      disabled = "disabled=\"disabled\"";
                    }
                    let str = "<select  "+disabled+"  class=\"form-control input-props type-props\" id=\"type_" + row.propertyId +"\" data-type=\"" + row.type + "\" data-origins=\"" + row.origins + "\">";
                    for (let j = 0, lej = row.propertiesType.length; j < lej; j++){
                      let selected = "";
                      if (row.propertiesType[j].value == data){
                        selected = "selected=\"selected\"";
                      }
                      
                      
                      str += "<option " + disabled2 + " value=\""+row.propertiesType[j].value+"\" " + selected + ">" + row.propertiesType[j].text + "</option>";
                      
                    }
                    str += "</select>";


                    return  str;
                  }else if(meta.col == 6){


                    let  accepted = row.isRequiredOnRequest;
                    let checked = "";
                    if (row.isRequiredOnRequest == true){

                      checked = "checked";
                    }

                    let str = "<div class=\"custom-control custom-checkbox input-props\"><input "+disabled+" " + checked + "  type=\"checkbox\" class=\"custom-control checkbox_type custom-control-primary custom-control-sm\" id=\"request_" + row.propertyId +"\" value=\""+ accepted +"\"></div>";

                    return  str;
                  }else if(meta.col == 7){
                    let  accepted = row.isRequiredOnRelease;
                    let checked = "";
                    if (row.isRequiredOnRelease == true){

                      checked = "checked";
                    }

                    let str = "<div class=\"custom-control custom-checkbox input-props\"><input "+disabled+" " + checked + "  type=\"checkbox\" class=\"custom-control checkbox_type custom-control-primary custom-control-sm\" id=\"release_" + row.propertyId +"\" value=\""+ accepted +"\"></div>";

                    return  str;
                  }else if(meta.col == 8){
                    let  accepted = row.isRevisionChanging;
                    let checked = "";
                    if (row.isRevisionChanging == true){

                      checked = "checked";
                    }

                    let str = "<div class=\"custom-control custom-checkbox\"><input "+disabled+" " + checked + "  type=\"checkbox\" class=\"custom-control checkbox_type custom-control-primary custom-control-sm input-props\" id=\"revision_" + row.propertyId +"\" value=\""+ accepted +"\"></div>";

                    return  str;
                  }else if(meta.col == 9){
                    let  accepted = row.isSearchString;
                    let checked = "";
                    if (row.isSearchString == true){

                      checked = "checked";
                    }

                    let str = "<div class=\"custom-control custom-checkbox input-props\"><input  "+disabled+" " + checked + "  type=\"checkbox\" class=\"custom-control checkbox_type custom-control-primary custom-control-sm\" id=\"searchstring_" + row.propertyId +"\" value=\""+ accepted +"\"></div>";

                    return  str;
                  }else if(meta.col == 10){
                    let str = "<select  "+disabled+"  class=\"form-control input-props type-props\" id=\"designation_" + row.propertyId +"\">";
                    for (let j = 0, lej = row.designationTypes.length; j < lej; j++){
                      let selected = "";
                      if (row.designationTypes[j].type == data){
                        selected = "selected=\"selected\"";
                      }
                      let disabled = "";
                      if (row.type == PartPropertiesType.PARTNUMBER){
                        if (row.designationTypes[j].type == 0 || row.designationTypes[j].type == 1){
                          disabled = "disabled=\"disabled\"";
                        }
                        
                      }
                      if (row.type == PartPropertiesType.SYMBOL){
                        
                        if (row.designationTypes[j].type != 4 ){
                          disabled = "disabled=\"disabled\"";
                          
                        }
                        
                      }
                      if (row.type == PartPropertiesType.FOOTPRINT){
                        if (row.designationTypes[j].type == 0 || row.designationTypes[j].type == 1){
                          disabled = "disabled=\"disabled\"";
                        }
                        
                      }
                      
                      str += "<option " + disabled + " value=\""+row.designationTypes[j].type+"\" " + selected + ">" + row.designationTypes[j].name + "</option>";
                    }
                    str += "</select>";


                    return  str;   
                    
                    
                  }else if(meta.col == 11){
                    let  accepted = row.isSearchString;
                    let checked = "";
                    if (row.cisBrowsable == true){

                      checked = "checked";
                    }

                    let str = "<div id=\"div#browsable_" + row.propertyId +"\" class=\"custom-control custom-checkbox input-props\"><input  "+disabled+" " + checked + "  type=\"checkbox\" class=\"custom-control checkbox_type custom-control-primary custom-control-sm browsable-props\" id=\"browsable_" + row.propertyId +"\" value=\""+ accepted +"\"></div>";

                    return str; 
                  } else if (meta.col == 12) {
                    let str = "<select  " + disabled + "  class=\"form-control input-props type-props\" id=\"hdldesignation_" + row.propertyId + "\">";
                    for (let j = 0, lej = row.designationHDLTypes.length; j < lej; j++) {
                      let selected = "";
                      
                      if (row.designationHDLTypes[j].type == data) {
                        selected = "selected=\"selected\"";
                      }
                      let disabled = "";
                      
                      str += "<option " + disabled + " value=\"" + row.designationHDLTypes[j].type + "\" " + selected + ">" + row.designationHDLTypes[j].name + "</option>";
                    }
                    str += "</select>";


                    return str;   
                  } else if (meta.col == 13) {
                    if (row.type == "part number") {
                      return "";
                    }
                    if (row.type == "type") {
                      return "";
                    }
                    
                    let str = "<input " + disabled + " min=\"0\" class=\"form-control input-props\" type=\"number\" id=\"maxLength_" + row.propertyId + "\" value=\"" + data + "\"></input>";
                    return str;

                  } else if (meta.col == 14) {
                    let str = "";
                    if (row.type == "library") {
                      str += "<select  " + disabled + "  class=\"form-control input-props type-props\" id=\"libraryCategoryId_" + row.propertyId + "\">";
                        
                      for (let j = 0, lej = row.libraryCategories.length; j < lej; j++) {
                        let selected = "";

                        if (row.libraryCategories[j].value == data) {
                          selected = "selected=\"selected\"";
                        }
                        

                        str += "<option  value=\"" + row.libraryCategories[j].value + "\" " + selected + ">" + row.libraryCategories[j].text + "</option>";
                      }
                      str += "</select>";
                    }
                    
                    
                    return str;
                  }else if(meta.col == 15){
                    // let str = "<button  class=\"btn btn-secondary btn-sm button_action_confirm\" id=\"button_confirm_" + row.propertyId +"\" >"+_vue.lang.button_Confirm+"</button>";
                    
                    if (row.type == PartPropertiesType.TYPE) {
                      disabled = "disabled=\"disabled\"";
                    }
                    if (row.type == PartPropertiesType.PARTNUMBER) {
                      disabled = "disabled=\"disabled\"";
                    }
                    let str = "<button "+disabled+"   class=\"btn btn-secondary btn-sm btn-"+_vue.variant+" button_action_delete\" id=\"button_delete_" + row.propertyId +"\" >"+_vue.lang.button_Delete+"</button>";

                    return  str;
                  }


                }
              }



              columnDefs.push(el);

              columnDefs.push({ "width": "70px", "targets": 2 });
              columnDefs.push({ "searchable": false, "targets": 5 });
              columnDefs.push({ "searchable": false, "targets": 10 });
              columnDefs.push({ "orderable": false, "targets": 1 });
              columnDefs.push({ "orderable": false, "targets": 2 });
              columnDefs.push({ "orderable": false, "targets": 3 });
              columnDefs.push({ "orderable": false, "targets": 4 });
              columnDefs.push({ "orderable": false, "targets": 5 });
              columnDefs.push({ "orderable": false, "targets": 6 });
              columnDefs.push({ "orderable": false, "targets": 7 });
              columnDefs.push({ "orderable": false, "targets": 8 });
              columnDefs.push({ "orderable": false, "targets": 9 });
              columnDefs.push({ "orderable": false, "targets": 10 });
              columnDefs.push({ "orderable": false, "targets": 11 });
              columnDefs.push({ "orderable": false, "targets": 12 });
              columnDefs.push({ "orderable": false, "targets": 13 });
              columnDefs.push({ "orderable": false, "targets": 14 });

              cols =  [
                  { "data": "propertyId" },
                  { "data": "priority" },
                  { "data": "priority" },
                  { "data": "origins" },
                  { "data": "name" },
                  { "data": "type" },
                  { "data": "RequiredOnRequest" },
                  { "data": "RequiredOnRelease" },
                  { "data": "RevisionChanging" },
                  { "data": "SearchString" },
                  { "data": "cisDesignation" },
                  { "data": "cisBrowsable" },
                  { "data": "hdlDesignation" },
                  { "data": "maxLength" },
                  { "data": "libraryCategoryId" },
              ]

              var th = document.createElement("th");
              //var th2 = document.createElement("th");
              tr1.appendChild(th);
              //tr2.appendChild(th2);
              //var p = document.createElement("p");
              //th.appendChild(p);
              var br = document.createElement("br");
              th.appendChild(br);

              var tx = document.createTextNode(columns[i].name)
              th.appendChild(tx);

            }
            



            var json = {};


            json.keys = false;
            json.data= this.properties;
            json.myColumnFormats = columns;
            json.colReorder = false;
            json.paging = false;
            json.select = false;
            json.columns = cols;
            json.columnDefs = columnDefs;
            json.dom = '<f<t>ip>';
            json.order = [1, "asc"];
            json.ordering = true;



                if ($.fn.dataTable.isDataTable('#place'+this._uid)) {
                    this.mainTable.destroy();

                }

                this.mainTable = $('#place'+this._uid).DataTable(json);
                this.mainTable.columns.adjust().draw();

                this.$parent.$parent.$parent.$parent.$parent.$parent.propsTable = this.mainTable;
                

                //hide first column in table
                this.mainTable.column( 0 ).visible( false );
                this.mainTable.column( 1 ).visible( false );
                if (this.$store.getters.appConf.status.isCIS == false){
                  this.mainTable.column( 10 ).visible( false );
                  this.mainTable.column( 11 ).visible( false );
            }
               
                if (this.$store.getters.appConf.status.isHDL == false) {
                  this.mainTable.column(12).visible(false);
                  
                  
                }
                

                //search input change view
                var searchplace = document.getElementById("place"+this._uid+"_filter").firstChild

                while (searchplace.firstChild) {

                  if (searchplace.firstChild.textContent == "Search:"){
                      searchplace.removeChild(searchplace.firstChild);
                      break;
                  }

                }


                searchplace.firstChild.setAttribute("placeholder", "Enter search words")
                searchplace.firstChild.setAttribute("class", "form-control form-control-sm");
                searchplace.firstChild.setAttribute("id", "props_search");
                searchplace.firstChild.addEventListener("input", function(evt){

                 _vue.$store.dispatch("setFilteredData", evt.target.value);

                })


              let buttons_action_delete = document.getElementsByClassName('button_action_delete');


              for (var i = 0; i < buttons_action_delete.length; i++) {
                buttons_action_delete[i].addEventListener('click', function (vue){


                  var tr = $(this).closest('tr');
                  var row = _vue.mainTable.row( tr );

                  var data = row.data();


                  let type = data.type;
                  
                  // let name = document.getElementById("name_"+ data.propertyId);
                  // let type = document.getElementById("type_"+ data.propertyId);
                  // let request = document.getElementById("request_"+ data.propertyId);
                  // let release = document.getElementById("release_"+ data.propertyId);
                  // let revision = document.getElementById("revision_"+ data.propertyId);

                  _vue.$store.dispatch("setPropertyId", data.propertyId)



                  let deleteProp = function(vue){
                                        
                    let obj = {
                      propertyId: _vue.$store.getters.propertyId
                    }
                    
                    

                    _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteProperty", obj)
                    .then(function(result) {
                      
                      console.log(result)

                      
                      if (result.data == 1){


                        const obj = {
                          text: _vue.lang.alert_success_Delete,
                          time: 5,
                          type: "success"
                        }

                        _vue.$store.dispatch("displayFooterAlert", obj);

                        
                        const reloadObj = {
                            status: true,
                            name: "FormPartPropertiesComponent"
                        }
                        _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                      }else{
                        

                        const obj = {
                          text: _vue.lang.alert_error_Delete,
                          time: 10,
                          type: "danger"
                        }

                        _vue.$store.dispatch("displayFooterAlert", obj);

                      }



                    })
                  }
                  
                  let text = _vue.lang.alert_Text;
                  if (type != "text"){
                    text = _vue.lang.alert_Text_Special;
                  }

                  var obj = {
                    title: _vue.lang.alert_Title,
                    text: text,
                    type: "sure",
                    buttons: 2,
                    size: "sm",
                    funcNo: "",
                    funcYes: deleteProp

                  }
                  _vue.$store.dispatch("showAlert", obj);



                }, false);
              }

              
              $("#place"+this._uid + " tbody").on( "input", ".input-props", function (e) {

                //let elements = document.getElementsByClassName("type-props");

                                
                // let trig = 0;
                // for (let i = 0, lei = elements.length; i < lei; i++){

                  
                //   if (elements[i].value == "part number"){
                //     trig += 1;
                    
                //   }
                // }
                // console.log(trig)
                // _vue.$store.dispatch("setDuplicatePartNumber", trig);
                
                
                let temp = e.target.id.split("_")
            
              
                //var data = _vue.mainTable.row( $(this).parents('tr') ).data();
                
                
                let field = document.getElementById(e.target.id)
                
                

                for (let i = 0, lei = _vue.properties.length; i < lei; i++){
                  if (temp[1] == _vue.properties[i].propertyId){
                    
                    if (temp[0] == "name"){
                      _vue.properties[i].name = field.value
                    }
                    if (temp[0] == "type"){
                      _vue.properties[i].type = field.value
                    }
                    if (temp[0] == "request"){
                      _vue.properties[i].isRequiredOnRequest = field.checked
                    }
                    if (temp[0] == "release"){
                      _vue.properties[i].isRequiredOnRelease = field.checked
                    }
                    if (temp[0] == "revision"){
                      _vue.properties[i].isRevisionChanging = field.checked
                    }
                    if (temp[0] == "searchstring"){
                      _vue.properties[i].isSearchString = field.checked
                    }
                    if (temp[0] == "designation"){
                      _vue.properties[i].cisDesignation = field.value
                    }
                    if (temp[0] == "browsable"){
                      _vue.properties[i].cisBrowsable = field.checked
                    }
                    if (temp[0] == "hdldesignation") {
                      _vue.properties[i].hdlDesignation = field.value
                    }
                    if (temp[0] == "maxLength") {
                      if (field.value == 0) {

                        _vue.properties[i].maxLength = null;
                        field.value = null;
                      }
                      _vue.properties[i].maxLength = field.value
                    }
                    if (temp[0] == "libraryCategoryId") {
                      _vue.properties[i].libraryCategoryId = field.value
                    }

                    _vue.$store.dispatch("addPropertyToSaving", _vue.properties[i])
                  }
                }

              })

            let buttons_action_arrow = document.getElementsByClassName('btn-arrow');
            

            for (var i = 0; i < buttons_action_arrow.length; i++) {
              buttons_action_arrow[i].addEventListener('click', function (vue) {
                

                let tab = this.id.split("__");
                let dir = tab[0];
                let propertyId = tab[1];

                

                const obj = {
                  dir: dir,
                  propertyId: propertyId,
                  categoryId: _vue.$store.getters.selectedTreeItemObject.categoryId
                }

                _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_changePropertyPriority", obj)
                  .then((result) => {

                    console.log(result)


                    if (result.data != null) {


                      const obj = {
                        text: _vue.lang.alert_success_ChangePriority,
                        time: 10,
                        type: "success"
                      }

                      _vue.$store.dispatch("displayFooterAlert", obj);


                      const reloadObj = {
                        status: true,
                        name: "FormPartPropertiesComponent"
                      }
                      
                      _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                    } else {


                      const obj = {
                        text: _vue.lang.alert_error_ChangePriority + " Error: " + result.message,
                        time: 15,
                        type: "danger"
                      }

                      _vue.$store.dispatch("displayFooterAlert", obj);

                    }

                  
                })
              })
              
            }
            
          },
          
        }


    }
</script>
<style lang="scss">


  .FormPartPropertiesComponent{

    table{
      width: 100%;
      font-size: 0.75rem;

    }

    table th {
      padding: 2px !important;

    }
    .table thead th {
        vertical-align:top;
        border-bottom: 3px solid;
    }
    table td {
      padding: 2px !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 80px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }
    .processing-top{
      top: 80px;
    }
    .processing-top-plugin{
      top: 160px;
    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .progress{
      width: 200px;

    }
    .dataTables_filter{
    float: left;
    font-size: 10px;
    }

    .dt-buttons{
      float: left;

      margin-left: 100px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .custom-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
      //text-align: center;
    }
    .dt-button-collection{

      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;

    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .form-control {
      padding: 0.075rem 0.75rem;
    }
    .button_action_delete{
      margin: 2px 2px 2px 5px;
    }
  }

  .blackIcon{
    background: #333;
  }
  .btn-arrow{
    padding: 2px;
    margin: 2px;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/FormPartPropertiesComponent.vue